angular.module('core')
  .service('profileApi', ['cancelableResourceFactory', function ($cancelableResourceFactory) {
      var self = this;

      self.ACADEMIC_PROGRAM = 'academic_program';
      self.THIRD_PARTY_ASSESSMENT = 'third_party_assessment';
      self.HIDE_FTUE = 'hide_ftue';

      var CustomerProfileValues = $cancelableResourceFactory.createCacheableResource(null, '/p/customers/:id/settings/:name', {
          id: '@customerId',
          school_id: '@schoolId',
          classroom_id: '@classroomId',
          name: '@name'
      }, {
          get: {
              method: 'GET'
          }
      });

    // non resolvable customer preferences that exist solely for the currently logged in customer

    var CustomerPreferencesValues = $cancelableResourceFactory.createCacheableResource(null, '/api/v1/districts/:id/customers/me/preferences/:name', {
      id: '@id',
      name: '@name'
    }, {
      getPreference: {
        method: 'GET'
      },
      setPreference: {
        method: 'PUT',
      }
    });

    var DistrictProfileValues = $cancelableResourceFactory.createCacheableResource(null, '/p/districts/:id/settings/:name', {
          id: '@districtId',
          school_id: '@schoolId',
          name: '@name'
      }, {
          get: {
              method: 'GET'
          }
      });

      /**************************************************************/
      /*                          Api                               */
      /**************************************************************/

      // Resolves a profile setting for a given customer.
      self.getCustomerSetting = function(customerId, schoolId, classroomId, name) {
          var rtn = CustomerProfileValues.get({
              id: customerId,
              school_id: schoolId ? schoolId : '',
              classroom_id: classroomId ? classroomId : '',
              name: name
          });
          return rtn.$promise;
      };

    // Gets a non resolveable preference for the currently logged in customer.
    self.getCustomerPreference = function(districtId, name) {
      console.log ("getting preference: " + name + " for current customer in district: " + districtId);
      var rtn = CustomerPreferencesValues.getPreference({
        id: districtId,
        name: name
      });
      return rtn.$promise;
    };

    // Sets a non resolveable preference for the currently logged in customer.
    self.setCustomerPreference = function(districtId, name, value) {
      console.log ("setting preference: " + name + " for current customer in district: " + districtId);
      var rtn = CustomerPreferencesValues.setPreference({
        id: districtId,
        name: name,
        value: value
      });
      return rtn.$promise;
    };

    // Resolves a profile setting for a given district.
      self.getDistrictSetting = function(districtId, schoolId, name) {
          var rtn = DistrictProfileValues.get({
              id: districtId,
              school_id: schoolId ? schoolId : '',
              name: name
          });
          return rtn.$promise;
      };
  }]);
